@if (list().length) {
    <div class="breadcrumb text-xs flex items-center">
        @for(breadcrumb of list(); track breadcrumb.label; let last = $last) {
            <span>{{breadcrumb.label}}</span>
            @if(!last) {
                <mat-icon fontIcon="keyboard_arrow_right" color="primary"></mat-icon>
            }
        }
    </div>
}